const parseBool = (value) => String(value).toLowerCase() === 'true';

export const featureFlags = {
  useFastApi: parseBool(process.env.VUE_APP_USE_FAST_API),
};
